import { render, staticRenderFns } from "./ed-designer-text.component.vue?vue&type=template&id=ce8bd1f4&scoped=true&"
import script from "./ed-designer-text.component.ts?vue&type=script&lang=ts&"
export * from "./ed-designer-text.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-designer-text.component.scss?vue&type=style&index=0&id=ce8bd1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8bd1f4",
  null
  
)

export default component.exports